import { read, utils } from 'xlsx';

import { mapExcelKeysToUppercase } from 'modules/_shared/components/Modals/Constitution/utils/mapExcelKeysToUppercase';

import { SharesTransferExcelRawRow } from '../types/SharesTransferExcel';

export type ParseSharesTransferExcelResult =
  | { success: true; rows: SharesTransferExcelRawRow[] }
  | { success: false; error: string };

const SHEET_NAME = 'Transacciones';

export const parseSharesTransferExcel = async (
  file: File
): Promise<ParseSharesTransferExcelResult> => {
  try {
    const data = await file.arrayBuffer();
    const workbook = read(data, { cellDates: true });
    const sheet = workbook.Sheets[SHEET_NAME];

    if (!sheet) {
      return { success: false, error: 'SHEET_NOT_FOUND' };
    }

    const rawRows = utils.sheet_to_json(sheet, { defval: null });
    const rows = mapExcelKeysToUppercase(
      rawRows as SharesTransferExcelRawRow[]
    );

    return { success: true, rows };
  } catch {
    return { success: false, error: 'SHEET_NOT_FOUND' };
  }
};
